import { LocalAudioTrack } from 'twilio-video';
import { useVideoContext } from '../hooks';
import { AudioLevelIndicator } from './audio-level-indicator';

export function LocalAudioLevelIndicator() {
  const { localTracks } = useVideoContext();
  const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;

  return <AudioLevelIndicator audioTrack={audioTrack} />;
}
